import { OS } from "@/lib/utils/getDeviceOs";
import { RedirectionUrls } from "@/components/redirectFlow/ClientRedirect.types";
import { ANDROID_CLICK_ID_PLACEHOLDER } from "@/lib/utils/linkUtils";

/**
 * Pick where this visitor should be sent. `undefined` means no destination
 * exists for their OS at all — the caller surfaces that as a failure instead of
 * leaving them on a spinner.
 */
export function resolveRedirectionUrl(
  os: OS,
  { web, ios, android }: RedirectionUrls
): string | undefined {
  // The store URLs are null when the app has no id for that store, so a mobile
  // visitor falls through to the web destination rather than being sent to a
  // dead store page. Mirrors resolveDestination in /api/link/continue.
  if (os === "ios" && ios) return ios;
  if (os === "android" && android) return android;
  if (web) return web;

  // web but fallback doesn't exist, try store redirects before failing
  if ((os === "windows" || os === "linux") && android) return android;
  if (os === "mac os" && ios) return ios;

  return undefined;
}

/**
 * Fill the Play Store install referrer with the real click id, which only exists
 * after the page was rendered with the placeholder. A URL without the
 * placeholder is an Android override: no referrer channel, so that install is
 * matched by fingerprint instead.
 */
export function patchAndroidClickId(url: string, clickId: string): string {
  if (!url.includes(ANDROID_CLICK_ID_PLACEHOLDER)) return url;
  return url.replace(ANDROID_CLICK_ID_PLACEHOLDER, `click_id%3D${clickId}`);
}
